export default {
	init() {
		if (!document.querySelector(".theme-button, .wpforms-page-button")) {
			return;
		}

		const CIRCLE_HOVER_BUTTON_SELECTOR =
			".theme-button, .wpforms-page-button, .wpforms-field-label-inline";

		const setButtonCircle = (event, button) => {
			const rect = button.getBoundingClientRect();

			const x = ((event.clientX - rect.left) / rect.width) * 100;
			const y = ((event.clientY - rect.top) / rect.height) * 100;

			button.style.setProperty("--enter-x", `${x}%`);
			button.style.setProperty("--enter-y", `${y}%`);
		};

		this.buttons = document.querySelectorAll(CIRCLE_HOVER_BUTTON_SELECTOR);

		this.buttons.forEach((button) => {
			button._setButtonCircle = (e) => setButtonCircle(e, button);

			button.addEventListener("pointerenter", button._setButtonCircle);
			button.addEventListener("pointerleave", button._setButtonCircle);
		});
	},

	destroy() {
		if (!this.buttons) {
			return;
		}

		this.buttons.forEach((button) => {
			button.removeEventListener("pointerenter", button._setButtonCircle);
			button.removeEventListener("pointerleave", button._setButtonCircle);

			delete button._setButtonCircle;
		});

		this.buttons = null;
	},
};
